import type { Component } from 'vue';
import DonutChart from './DonutChart.vue';


export default new Map<string, Component>([
  ['DonutChart', DonutChart],  
]);



